import { type MessagingMessage, MessagingStatus } from "@/model/messaging";

export function isMessageOtherRead(args: {
  deliveredStatus: MessagingMessage["payload"]["deliveredStatus"];
  myselfExternalId?: string;
  participants?: Array<{
    externalId?: string;
  }>;
}) {
  const { deliveredStatus, myselfExternalId, participants } = args;

  const others = participants?.filter((p) => p.externalId !== myselfExternalId);

  return others?.some(
    (item) => deliveredStatus?.[item.externalId!] === MessagingStatus.Read
  );
}

export function isMessageRead(args: {
  deliveredStatus: MessagingMessage["payload"]["deliveredStatus"];
  myselfExternalId: string;
}) {
  const { deliveredStatus, myselfExternalId } = args;

  return deliveredStatus?.[myselfExternalId] === MessagingStatus.Read;
}
